import { z } from 'zod'
import { requestEnvelope } from './client'

/** 与 API.md §2 契约一致：POST /alerts/publish 与 /alerts/broadcast（v1） */
const publishResponseSchema = z.object({
  topic: z.string(),
  message_id: z.string(),
  geohash: z.string(),
  qos: z.number(),
})
export type AlertPublishResponse = z.infer<typeof publishResponseSchema>

export interface AlertPublishInput {
  level: 'BE_AWARE' | 'TAKE_ACTION'
  magnitude: number
  epicenterLat: number
  epicenterLon: number
  epicenterName: string
  /** 震源深度 km */
  depth: number
  /** S 波预计到达秒数 */
  estimatedArrivalSec: number
}

function toBody(input: AlertPublishInput) {
  return JSON.stringify({
    level: input.level,
    magnitude: input.magnitude,
    epicenter_lat: input.epicenterLat,
    epicenter_lon: input.epicenterLon,
    epicenter_name: input.epicenterName,
    depth: input.depth,
    estimated_arrival_sec: Math.round(input.estimatedArrivalSec),
    // geohash 留空：后端从经纬度计算
  })
}

/** 区域发布（geohash 区域推送） */
export function publishAlert(input: AlertPublishInput): Promise<AlertPublishResponse> {
  return requestEnvelope('/alerts/publish', publishResponseSchema, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: toBody(input),
  })
}

/** 全量广播（所有客户端） */
export function broadcastAlert(input: AlertPublishInput): Promise<AlertPublishResponse> {
  return requestEnvelope('/alerts/broadcast', publishResponseSchema, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: toBody(input),
  })
}
